import { FC, useState } from 'react'
import { motion } from 'framer-motion'
import { MdInventory2 } from 'react-icons/md'
import { enqueueSnackbar } from 'notistack'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { webApiService } from '@/services'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { IAppStore } from '@/models/store.model'
import StepCard from './StepCard'
import { useStepFooterAction } from '../context/StepFooterActionContext'
import { useTradeinContext } from '../hooks/useTradeinContext'

const ReceiveCard: FC = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  const { id } = useParams()
  const [recipientName, setRecipientName] = useState('')
  const [recipientLastname, setRecipientLastname] = useState('')
  const [recipientRut, setRecipientRut] = useState('')
  const [loading, setLoading] = useState(false)

  const handleRecibir = () => {
    setLoading(true)
    webApiService.update({
      id_tradein: String(id ?? ctx.tradein.id),
      id_user: userState.id,
      stage: 6,
      id_role: userState.id_role,
      email: userState.email,
      client_email: ctx.tradein.email,
      id_seller: ctx.tradein.id_seller,
      rut: '',
      client_name: ctx.tradein.name,
      client_lastname: ctx.tradein.lastname,
      url_contract: ctx.tradein.url_contract,
      recipient_name: recipientName,
      recipient_lastname: recipientLastname,
      recipient_rut: recipientRut,
      recipient_id: '',
      device_purchased: ctx.tradein.device_purchased
    })
      .then(() => {
        enqueueSnackbar('Estado actualizado a Entregado', { variant: 'success' })
        setLoading(false)
        saveCtx({ ...ctx, reload: true })
      })
      .catch((error: any) => {
        enqueueSnackbar(error.message ?? 'Hubo un error al recibir el equipo.', { variant: 'error' })
        setLoading(false)
      })
  }

  const isDisabled = recipientName.trim() === '' || recipientLastname.trim() === '' || recipientRut.trim() === ''
  const filledCount = [recipientName, recipientLastname, recipientRut].filter((v) => v.trim() !== '').length

  const inlineAction = useStepFooterAction(
    (
      <Button onClick={handleRecibir} disabled={isDisabled || loading}>
        {loading ? 'Enviando...' : 'Recibir equipo'}
      </Button>
    ),
    [isDisabled, loading, recipientName, recipientLastname, recipientRut]
  )

  return (
    <StepCard icon={<MdInventory2 />} title='Recepción del equipo' subtitle='Último paso antes de finalizar'>
      <p className='text-sm text-slate-500 mb-4'>Confirma que el cliente entregó el dispositivo restablecido, desvinculado y sin contraseñas de acceso.</p>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-1.5'>
          <label className='text-xs uppercase tracking-widest text-slate-500'>Nombre del vendedor</label>
          <Input value={recipientName} onChange={(e) => setRecipientName(e.target.value)} placeholder='Nombre' />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label className='text-xs uppercase tracking-widest text-slate-500'>Apellido del vendedor</label>
          <Input value={recipientLastname} onChange={(e) => setRecipientLastname(e.target.value)} placeholder='Apellido' />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label className='text-xs uppercase tracking-widest text-slate-500'>{import.meta.env.VITE_LABEL_RUT ?? 'RUT'} del vendedor</label>
          <Input value={recipientRut} onChange={(e) => setRecipientRut(e.target.value)} placeholder={import.meta.env.VITE_LABEL_RUT ?? 'RUT'} />
        </div>
      </div>
      <div className='mt-4 h-1 w-full overflow-hidden rounded-full bg-slate-100'>
        <motion.div
          className='h-full rounded-full bg-[#4b75f7]'
          initial={false}
          animate={{ width: `${(filledCount / 3) * 100}%` }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
        />
      </div>
      {/* Sin footer compartido (página de detalle clásica) el botón del paso se dibuja acá. */}
      {inlineAction && <div className='flex justify-end pt-4'>{inlineAction}</div>}
    </StepCard>
  )
}

export default ReceiveCard
